import * as api from '../salesCallApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { IEntityWithMessages } from '../../../services/HttpService';
import {
  ISalesCall,
  salesCallActionCreators,
  SalesCallActionKeys,
  UpdateSalesCall
  } from '..';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* updateSalesCallSaga(action: UpdateSalesCall) {
  yield put(uiActionCreators.showSpinnerDialog());

  try {
    const response: IEntityWithMessages<ISalesCall> = yield call(api.updateSalesCall, action.payload);

    if (!response.error && response.value) {
      yield put(salesCallActionCreators.processSalesCalls([response.value]));
    }

    yield processMessages(response);
    yield put(uiActionCreators.hideSalesCallDialog());
  } catch (error) {
    //
    yield put(
      uiActionCreators.showMessageDialog({
        messages: ['There was a problem updating this sales call.  Please retry.'],
        title: 'An error occured'
      })
    );
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateSalesCall() {
  yield takeEvery(SalesCallActionKeys.UPDATE_SALESCALL, updateSalesCallSaga);
}
